/**
 * Service Worker 캐시 정리 유틸리티
 * 주기적으로 오래된 미디어 파일 캐시를 삭제합니다.
 */

/**
 * Service Worker에 캐시 정리 메시지 전송
 */
export const triggerCacheCleanup = () => {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'CLEANUP_OLD_CACHE',
    });
    console.log('Cache cleanup triggered');
  }
};

/**
 * 주기적 캐시 정리 시작
 * @param {number} intervalHours - 정리 주기 (시간 단위, 기본값: 24시간)
 */
export const startPeriodicCacheCleanup = (intervalHours = 24) => {
  // 즉시 한 번 실행
  triggerCacheCleanup();

  // 주기적으로 실행
  const intervalMs = intervalHours * 60 * 60 * 1000;
  const intervalId = setInterval(triggerCacheCleanup, intervalMs);

  // 정리 함수 반환
  return () => clearInterval(intervalId);
};

/**
 * 앱 시작 시 캐시 정리 초기화
 * App.js나 index.js에서 호출하세요.
 */
export const initCacheCleanup = () => {
  // Service Worker 등록 완료 후 캐시 정리 시작
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(() => {
      startPeriodicCacheCleanup(24); // 24시간마다 정리
    });
  }
};
